<template>
    <ul class="my-3 d-flex justify-content-center pagination"
        v-if="lastPage > 0">
        <li class="px-2 cursorPoint"
            v-if="currentPage!==1"
            @click="previous()"
            :data-ga-element="`${gaData}上一頁`">
            <ChevronsLeftIcon size="1x"
                              stroke-width="1"
                              class="mb-1" /> 上一頁
        </li>
        <!-- :class="{active: item=currentPage}" -->
        <li class="page"
            v-for="n in pageList"
            :key="n"
            :class="{active: n===currentPage, cursorPoint: n!==currentPage}"
            :data-ga-element="`${gaData}第${n}頁`"
            @click="emitPage(n)">{{n}}</li>
        <li class="px-2 cursorPoint"
            v-if="currentPage!==lastPage"
            @click="next()"
            :data-ga-element="`${gaData}下一頁`">
            下一頁
            <ChevronsRightIcon size="1x"
                               stroke-width="1"
                               class="mb-1" />
        </li>
    </ul>

</template>
<script>
import { ChevronsLeftIcon, ChevronsRightIcon } from 'vue-feather-icons';
export default {
    name: 'Pagination',
    components: { ChevronsLeftIcon, ChevronsRightIcon },
    props: {
        lastPage: { type: Number, default: 1 },
        currentPage: { type: Number, default: 1 },
        gaData: { type: String, default: '健康及保險知識+|' }
    },
    data() {
        return {
            firstPage: 1,
        };
    },
    computed: {
        pageList() {
            const currentPage = this.currentPage;
            let pageList = [currentPage - 1, currentPage, currentPage + 1];
            if (currentPage === 1) {
                pageList = pageList.map(x => x + 1);
            }
            if (currentPage === this.lastPage) {
                pageList = pageList.map(i => i - 1);
            }
            pageList = pageList.filter(i => {
                return i <= this.lastPage && i > 0;
            });
            return pageList;
        },
    },
    methods: {
        previous() {
            this.emitPage(this.currentPage - 1);
        },
        next() {
            this.emitPage(this.currentPage + 1);
        },
        emitPage(page) {
            if (this.currentPage !== page) {
                this.$emit('getPage', page);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.pagination {
    font-size: 0.875rem;
    @include media-breakpoint-up(md) {
        font-size: 1rem;
    }
    li {
        border-radius: $radius;
        background-color: #f5f5f5;
        color: $gray-400;
        margin: 2px;
        line-height: 35px;
        text-align: center;
        &.active {
            color: $white;
            background-color: $primary;
        }
        &:hover {
            color: $white;
            background-color: $primary;
            svg {
                color: $white;
            }
        }
    }
    .page {
        min-width: 35px;
        height: 35px;
        padding-left: 0.2rem;
        padding-right: 0.2rem;
    }
}
</style>
